import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ProxyAccessEffects } from './data-access/store/effects/proxy-access.effects';
import { proxyAccessReducer } from './data-access/store/reducer/proxy-access.reducer';

/**
 * Proxy-access store, exported separately from `PATIENT_FEATURE_PROVIDERS` because this feature has
 * two entry points and only one of them is inside the patient area:
 *
 * - `patient/:patientId/proxy-access-form` — covered by `PATIENT_FEATURE_PROVIDERS`.
 * - `proxy-access-request` (public, caregiver-initiated) — a root route, so it inherits none of the
 *   patient-area providers. Without these the form would dispatch into the void (no effect, so no
 *   POST) and its selectors would read a feature key that isn't registered.
 *
 * Register these **once per flow**, on the route that parents every screen in it — the patient-area
 * route for one entry point, the component-less public parent in `app.routes.ts` for the other. Both
 * flows pass the accepted request from the form to the confirmation screen through this slice, so the
 * injector holding it has to outlive that navigation.
 *
 * Being reachable from two live injectors would still be safe if it ever happened: `provideState` is a
 * no-op for an already registered key, and `EffectSources` de-duplicates by effect class, so a second
 * `ProxyAccessEffects` instance never doubles the POST.
 */
export const PROXY_ACCESS_PROVIDERS = [
  provideState({ name: 'proxy-access', reducer: proxyAccessReducer }),
  provideEffects([ProxyAccessEffects]),
];
